
require('../../static/css/reset.css');
require('../../sass/common/reset.scss');

require('../../common/layout/header/header').run('noLogin');
require('../../common/layout/footer/footer').run();

require('../../sass/common/footer_link_html.scss');

$(document).ready(function(){
    $(".joinUs-item").on("click",function(){
        $(this).siblings().removeClass('current');
        $(this).addClass('current');
        
        $('.acArea2>div').addClass('hidden');
        $('.acArea2>div[data-for="' + $(this).attr('id') + '"]').removeClass('hidden');
    });
    
    
    let queryString = require('../../common/util').queryString;
    const joinUsId = queryString('id')
    
    if (joinUsId){
        $(".joinUs-item[id='" + joinUsId + "']").trigger('click');
    }
    const tel = joinUsId == 'joinUs_1' ? '0755-33246754' : '0755-33389891';
    // const email = joinUsId == 'joinUs_1' ? 'jlpingtai@corp.jl-tour.com' : 'zoujunping@corp.jl-tour.com';
    const email = joinUsId == 'joinUs_1' ? 'sale_02@corp.jl-tour.com' : 'sale_02@corp.jl-tour.com';
    $('.joinUs_tel').text(tel)
    $('.joinUs_email').text(email)
    
});


// WEBPACK FOOTER //
// ./src/js/joinUs/joinUs.js